export const buildRequiredRule = (value = true, message = "Pflichtfeld") => {
  return {
    required: {
      value: value,
      message: message,
    },
  };
};
